<nz-modal [nzMaskClosable]='false'
          [nzWidth]='1000'
          [nzVisible]='_visible'
          [nzTitle]="'图片采集'"
          [nzFooter]='hscModalFooter'
          (nzAfterOpen)='openHSC()'
          (nzOnCancel)='handleCloseHSCModal()'>
  <div class='modal-main-content'>
    <div class='hsc-img-area'>
      <div class='img-area'><img id='bigPriDev' /></div>
      <div class='options-area'>
        <div><i class='icon iconfont icon-creamer-change' (click)="changeCamera()"></i></div>
        <div><i class='icon iconfont icon-file-scan' (click)="doDeskew()"></i></div>
        <div><i class='icon iconfont icon-rotate-right' (click)="hscWebsocket.turnRight()"></i></div>
        <div><i class='icon iconfont icon-rotate-left' (click)="hscWebsocket.turnLeft()"></i></div>
      </div>
    </div>
    <div [hidden]='true'>
      设备列表：<select id='devList' style='width: 120px'></select>
      <select id='modelList' style='width: 120px'></select>
      <select id='resolutionList' style='width: 120px'></select>
    </div>
    <!--  <div id="container" style="float:left;"> </div>-->
    <div class='file-list-area'>
      <div *ngFor='let item of hscWebsocket?.imgPathArray;let i = index' class='hsc-thumb'>
        <div class="hsc-img-box" (click)='openPreview(i)'>
          <img [src]='item.src'>
        </div>
<!--        <div><span>{{item.name}}</span></div>-->
        <div>
          <nz-select style="width: 130px;margin-top: 2px;" [(ngModel)]='item.fileType'>
            <nz-option *ngFor="let option of _fileTypeList" [nzValue]="option.wordValue" [nzLabel]="option.wordText"></nz-option>
          </nz-select>
        </div>
        <div class='hsc-delete' (click)='hscWebsocket.deleteFile(i)'><i class='icon iconfont icon-close'></i></div>
      </div>
    </div>
  </div>
  <ng-template #hscModalFooter>
    <button nz-button nzType='primary' (click)='hscWebsocket.getPhoto()'>
      拍摄
    </button>
    <button nz-button nzType='primary' [disabled]='hscWebsocket?.imgPathArray?.length < 1' (click)='exportFiles()'>
      上传
    </button>
<!--    <button nz-button class='modal-cancel-btn' (click)='handleCloseHSCModal()'>-->
<!--      关闭-->
<!--    </button>-->
  </ng-template>
</nz-modal>

<nz-modal [nzMaskClosable]='false'
          *ngIf='_visible'
          [nzWidth]='720'
          [nzVisible]='downloadModalVisible'
          [nzTitle]="'图片采集'"
          [nzFooter]='downloadModalFooter'
          (nzOnCancel)='handleCloseDownloadModal()'>
  <p>如果您之前安装过跨浏览器SDK控件，请尝试重新启动跨浏览器SDK控件。</p>
  <p>如果您之前没有安装过，<a
    href='https://publicbuckettest-1259078701.cos.ap-shanghai.myqcloud.com/plugin/%E8%B7%A8%E6%B5%8F%E8%A7%88%E5%99%A8%E6%8E%A7%E4%BB%B6SDK%201-18%20V2.3.0.exe'
    download target='_blank'>点此处下载安装</a></p>
  <ng-template #downloadModalFooter>
    <button nz-button nzType='primary' (click)='handleCloseDownloadModal()'>
      关闭
    </button>
  </ng-template>
</nz-modal>
